import styled from "styled-components";

import { Link as RouterLink } from "react-router-dom";

import { theme } from "../../../styles/theme";

type IProps = {
  invertColor: boolean;
};

export const Container = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  gap: 60px 0;
  font-family: ${theme.font.poppins};
  border-radius: ${theme.border.largeRadius};
  background: ${(props) =>
    props.invertColor
      ? "linear-gradient(180deg, #155a77 0%, #27aae1 100%)"
      : theme.colors.darkBlue};
  padding: 60px 40px;
  max-width: 400px;

  @media screen and (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding: 15px;
    border-radius: ${theme.border.radius};
    max-width: 368px;
    width: 100%;
    justify-content: space-between;
  }
`;

export const Title = styled.h1<IProps>`
  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  color: ${(props) =>
    props.invertColor ? theme.colors.white : theme.colors.blue100};
  display: flex;
  align-items: center;
  gap: 30px;

  path {
    fill: ${(props) =>
      props.invertColor ? theme.colors.darkBlue : theme.colors.blue400};
  }

  @media screen and (max-width: 768px) {
    font-size: ${theme.font.sizes.xxxsmall};
    gap: 0;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: ${theme.border.mediumRadius};

  &:hover {
    background-color: ${theme.colors.blue400};

    svg {
      path {
        fill: ${theme.colors.white};
      }

      @media screen and (max-width: 768px) {
        width: 28px;
        height: 28px;
      }
    }
  }

  transition: background-color 0.3s;

  svg {
    cursor: pointer;
    path {
      transition: fill 0.3s;
    }
  }
`;

export const Link = styled(RouterLink)<IProps>`
  width: 313px;
  background: ${(props) =>
    props.invertColor
      ? theme.colors.darkBlue
      : "linear-gradient(180deg, #155a77 0%, #27aae1 100%)"};
  border-radius: ${theme.border.mediumRadius};
  color: ${theme.colors.white};
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.semiBold};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  gap: 10px;
  text-decoration: none;

  &:hover {
    color: ${theme.colors.white};
  }

  path {
    fill: ${theme.colors.white};
  }

  @media screen and (max-width: 768px) {
    margin-top: 0;
    width: 174px;
    font-size: ${theme.font.sizes.xxxsmall};
    padding: 10px 0;
    border-radius: ${theme.border.smallRadius};
    font-weight: ${theme.font.normal};
  }
`;
